<template>
  <div class="mobile-shipment-address-col-component">
    <div>{{ t('site_pro.table.recipient') }}:</div>
    <div class="flex gap-1 items-center">
      <span>{{ `${shipment.delivery_info.first_name} ${shipment.delivery_info.last_name}` }}</span>
      <div>
        <template v-if="shipment.fr_data && shipment.fr_data.delivery_info">
          <Tooltip>
            <template #body>
              <div class="flex flex-col gap-1">
                <span class="text-sm">
                  {{ `${shipment.fr_data.delivery_info.first_name} ${shipment.fr_data.delivery_info.last_name}` }}
                </span>
                <span class="text-sm">
                  {{ `${shipment.fr_data.delivery_info.city}, ${shipment.fr_data.delivery_info.first_address}` }}
                </span>
                <span class="text-sm">
                  {{ `${t(shipment.fr_data.delivery_info.country_name)}, ${shipment.fr_data.delivery_info.zip}` }}
                </span>
                <span class="text-sm">{{ shipment.fr_data.delivery_info.phone_number }}</span>
              </div>
            </template>
            <div ref="tooltipToggleRef" class="tooltip-toggle">
              <i class="tooltip-icon fa-solid fa-location-dot" />
            </div>
          </Tooltip>
        </template>

        <template v-else>
          <div class="tooltip-toggle" @click="toggleTooltip()">
            <i class="tooltip-icon fa-solid fa-location-dot" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useLoaderStore } from '~/store/loader'
import { useSiteProContentStore } from '~/store/shipzeeProContentStore'
import type { AllPackageInterface } from '~/types/shipzeePro/packagesTypes'

const { t } = useLang()

const loader = useLoaderStore()
const shipzeeProContent = useSiteProContentStore()

const props = defineProps<{
  shipment: AllPackageInterface
}>()

const tooltipToggleRef = ref<HTMLDivElement>()

async function toggleTooltip() {
  await updateShipmentData()

  tooltipToggleRef.value?.click()
}

async function updateShipmentData(): Promise<void> {
  const item: AllPackageInterface = { ...props.shipment }

  loader.setLoader(true)

  if (!item.fr_data) {
    item.fr_data = await $fetch('/api/site-pro/get-forward-request-by-id', {
      method: 'POST',
      body: { id: item.id },
    })
    shipzeeProContent.updateAllItem(item)
  }

  loader.setLoader(false)
}
</script>

<style lang="postcss" scoped>
.mobile-shipment-address-col-component {
  @apply flex justify-between text-sm;

  :deep(.tooltip-toggle) {
    @apply flex items-center justify-center flex-shrink-0 h-6 w-6 rounded-full bg-neutral7 dark:bg-dmGray1 cursor-pointer;

    .tooltip-icon {
      @apply text-xs text-neutral3 dark:text-dmText3;
    }
  }
}
</style>
